import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { LockIcon } from 'lucide-react';
import { Countdown } from '../hooks/useCountdown';
type StickyCtaProps = {
  visible: boolean;
  checkoutUrl: string;
  countdown: Countdown;
};
export function StickyCta({
  visible,
  checkoutUrl,
  countdown
}: StickyCtaProps) {
  return <AnimatePresence data-id="element-118" data-mp="31ogdkdnk55tp">
      {visible && <motion.div initial={{
      y: 80,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 80,
      opacity: 0
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-white/10 bg-ink-950/95 backdrop-blur" data-id="element-119" data-mp="3pdiq573c48hc">
          <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-5 py-3" data-id="element-120" data-mp="3km0sarwlyo0l">
            <div className="min-w-0" data-id="element-121" data-mp="c6qsxrk3rwwi">
              <p className="truncate font-display text-sm font-bold text-white" data-id="element-122" data-mp="c5ph3kv9j6dq">
                Gym por Primera Vez — <span className="text-flame" data-id="element-123" data-mp="gz0fqypx8guk">$7 USD</span>
              </p>
              <p className="text-xs tabular-nums text-white/50" data-id="element-124" data-mp="76nmiko32gyg">
                Expira en {countdown.hours}:{countdown.minutes}:{countdown.seconds}
              </p>
            </div>
            <a href={checkoutUrl} target="_top" rel="noopener" className="inline-flex shrink-0 items-center gap-2 rounded-xl bg-flame px-5 py-3 font-display text-sm font-extrabold uppercase tracking-tight text-white outline-none transition-[transform,background-color] duration-150 ease-smooth hover:bg-flame-600 focus-visible:ring-4 focus-visible:ring-flame/40 active:scale-[0.985]" data-id="element-125" data-mp="gvyrbv3xszgj">
              <LockIcon className="h-4 w-4" aria-hidden="true" data-id="element-126" data-mp="zs737hrgg8kt" />
              Dame mi guía por $7
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}